/**
 * DataMissing - Pagina para datos no encontrados
 * Se muestra cuando se intenta acceder a un registro que no existe
 */
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '@/components/ui/Button';
import Icon from '@/components/AppIcon';

const DataMissing = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const message =
    location.state?.message ||
    'El registro solicitado no fue encontrado o ya no existe.';
  const entityType = location.state?.entityType || 'registro';
  const entityId = location.state?.entityId || null;

  const handleGoBack = () => {
    if (window.history.length > 2) {
      window.history.back();
    } else {
      navigate('/dashboard');
    }
  };

  const handleGoToList = () => {
    // Intentar redirigir a la lista correspondiente
    const fromPath = location.state?.from || '';

    if (fromPath.includes('/clientes/')) {
      navigate('/admin/catalogos');
    } else if (fromPath.includes('/proveedores/')) {
      navigate('/admin/catalogos');
    } else if (fromPath.includes('/obras/')) {
      navigate('/admin/control-financiero');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-amber-50 to-yellow-50 p-4">
      <div className="text-center max-w-md bg-white rounded-xl shadow-lg p-8">
        {/* Icono */}
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 bg-amber-100 rounded-full flex items-center justify-center">
            <Icon name="FileQuestion" className="w-12 h-12 text-amber-500" />
          </div>
        </div>

        {/* Titulo */}
        <h1 className="section-title text-gray-800 mb-2">
          Datos No Encontrados
        </h1>

        {/* Mensaje */}
        <p className="text-gray-600 mb-6">{message}</p>

        {/* Info del registro */}
        {entityId && (
          <div className="mb-6 p-3 bg-amber-50 rounded-lg">
            <p className="text-sm text-amber-700">
              <span className="capitalize">{entityType}</span> ID:{' '}
              <code className="font-mono">{entityId}</code>
            </p>
          </div>
        )}

        {/* Posibles causas */}
        <div className="mb-6 text-left bg-gray-50 rounded-lg p-4">
          <p className="text-sm font-medium text-gray-700 mb-2">
            Posibles causas:
          </p>
          <ul className="text-sm text-gray-600 space-y-1">
            <li className="flex items-start gap-2">
              <Icon
                name="ChevronRight"
                className="w-4 h-4 mt-0.5 text-gray-400"
              />
              El {entityType} fue eliminado
            </li>
            <li className="flex items-start gap-2">
              <Icon
                name="ChevronRight"
                className="w-4 h-4 mt-0.5 text-gray-400"
              />
              El enlace es incorrecto o esta desactualizado
            </li>
            <li className="flex items-start gap-2">
              <Icon
                name="ChevronRight"
                className="w-4 h-4 mt-0.5 text-gray-400"
              />
              No tienes permisos para ver este {entityType}
            </li>
          </ul>
        </div>

        {/* Botones */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="flex items-center justify-center gap-2"
          >
            <Icon name="ArrowLeft" className="w-4 h-4" />
            Regresar
          </Button>

          <Button
            variant="default"
            onClick={handleGoToList}
            className="flex items-center justify-center gap-2"
          >
            <Icon name="List" className="w-4 h-4" />
            Ver Lista
          </Button>
        </div>

        {/* Ayuda */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Si el problema persiste, contacta al administrador.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataMissing;
